module.exports = __webpack_public_path__ + "static/img/1.ac1c66b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/sp/1.png
// module id = 5d4J
// module chunks = 0